import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/delay';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {

  constructor() { }

  getAuthToken() {
    return localStorage.getItem(environment.token) || null;
  }

  setAuhToken(token: string) {
    localStorage.setItem(environment.token, token);
  } 
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts